import * as React from 'react';

import {CardWidget} from 'shells/card/card-widget/card-widget';
// @ts-expect-error - imported from .js/.jsx file
import {ListIcon} from 'shells/icon/svg/list-icon';

import {useGetLeadMarkup} from '../../../shared/hooks';

import {PipelineTasks} from './pipeline-tasks';

type Props = {
    leadId: string;
};

export function OldSalesProcessWidget(props: Props) {
    const [pipelineTasksHeight, setPipelineTasksHeight] = React.useState<number>(0);

    const {pipelineTasks, pipelineTasksCount, setDidRenderPipelineTasks, isLoading} =
        useGetLeadMarkup(props.leadId);

    React.useEffect(() => {
        const handleStageChange = () => {
            requestAnimationFrame(() => {
                const activeMilestone = document.querySelector(
                    '.state-active.process-milestone-container'
                );
                if (activeMilestone) {
                    // @ts-expect-error
                    const newHeight = activeMilestone.offsetHeight + 8;
                    setPipelineTasksHeight(newHeight);
                }
            });
        };

        // @ts-expect-error
        const stageEvent = window.Nut.modules.Process.events.ActiveStageChanged;
        if (stageEvent) {
            $(window).on(stageEvent, handleStageChange);

            return () => {
                $(window).off(stageEvent, handleStageChange);
            };
        }
    }, []);

    return (
        <CardWidget
            title='Sales process'
            titleHasDivider={true}
            isFullWidth={true}
            isLoading={isLoading}
            emptyStateProps={{
                isEmpty: !pipelineTasks,
                text: 'No sales process',
                icon: ListIcon,
                iconSize: 18,
            }}
        >
            {pipelineTasks && (
                <div className='mx-16 mt-4' style={{height: pipelineTasksHeight}}>
                    <PipelineTasks
                        pipelineTasks={pipelineTasks}
                        numTasks={pipelineTasksCount}
                        onRenderLeadMarkup={() => {
                            setDidRenderPipelineTasks(true);
                        }}
                    />
                </div>
            )}
        </CardWidget>
    );
}
